import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import CashlessRequestFinancials from "./CashlessRequestFinancials"
import { contractNameMapper } from './CashlesInfoText';
import CashlessDocuments from './CashlessDocuments'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CashlessFullDetails({ requestFullDetails }) {
  const [open, setOpen] = React.useState(false);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        onClick={handleClickOpen}
        style={{
          width: '100%',
          textAlgin: 'center',
          marginTop: '5px',
          fontSize: '12px'
        }}
      >
        Details
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {contractNameMapper(requestFullDetails.service_type, 'Service') +
                ' Full Details'}
            </Typography>
          </Toolbar>
        </AppBar>
        <CashlessRequestFinancials requestDetails={requestFullDetails}/>
      </Dialog>
    </div>
  );
}
